module.exports = __webpack_public_path__ + "images/stickers/taco-robot.a230a80a1bc7255368dd.png";